import styled, { css } from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';

import Banner from '../../layout/banner/Banner';
import PlaceImg from 'src/components/ui-kit/PlaceImg';

const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  border-radius: 39px;
  min-height: 750px;
  padding: 20px;
  gap: 32px;
  height: max-content;
  @media (max-width: ${mobilePoint}) {
    min-height: calc(100% + 600px);
  }
`;

const InnerWrapper = styled.div`
  position: absolute;
  top: 17%;
  align-items: center;
  @media (max-width: ${mobilePoint}) {
    width: 95%;
    height: max-content;
    top: 14%;
    text-align: center;
  }
`;

const Form = styled.div<{ bgColor: string }>`
  width: 564px;
  min-height: 512px;
  border: 2px solid ${colors.white};
  border-radius: 24px;
  padding: 36px 48px;
  background: linear-gradient(${(prop) => prop.bgColor}, ${colors.white} 10%);
  box-shadow: 5px 5px 5px rgba(67, 67, 67, 0.07);

  @media (max-width: ${mobilePoint}) {
    width: 100%;
    height: fit-content;
  }
`;

const AnnotationDiv = styled.div`
  color: ${colors.BlueGray_300};
  font-size: 14px;
  margin: 20px 20px;
  text-align: left;
`;

// 以下為輸出給各明細頁面的樣式
export const FormItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 8px;
  line-height: 40px;
  @media (max-width: ${mobilePoint}) {
    display: block;
    justify-content: unset;
    height: fit-content;
    text-align: left;
  }
`;

export const Title = styled.div<{ required?: boolean }>`
  font-size: 16px;
  color: ${colors.BlueGray_500};
  width: 40%;
  position: relative;
  @media (max-width: ${mobilePoint}) {
    width: 100%;
  }

  ${(props) =>
    props.required &&
    css`
      padding-left: 8px;
      :before {
        content: '•';
        color: ${colors.notice_red};
        position: absolute;
        font-size: 20px;
        top: -12px;
        left: -6px;
      }
    `}
`;

export const Content = styled.div<{ isWrong?: boolean }>`
  display: ${(prop) => (prop.isWrong ? 'block' : 'flex')};
  font-size: 16px;
  color: ${colors.BlueGray_800};
  width: 60%;
  @media (max-width: ${mobilePoint}) {
    display: block;
    width: 100%;
  }
  input {
    border: ${(prop) => prop.isWrong && '1px solid' + colors.notice_error};
  }
`;
export const Symbol = styled.span`
  width: 10%;
  text-align: center;
  line-height: 40px;
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
export const Button = styled.button`
  width: 100%;
  background-color: ${colors.yellow};
  border-radius: 8px;
  height: 48px;
  margin-top: 28px;
  font-family: NotoSansTC-Bold;
  position: relative;
  @media (max-width: ${mobilePoint}) {
    width: 160px;
  }
  span {
    position: absolute;
    right: 14px;
  }
`;
export const ErrorMsg = styled.div`
  font-size: 12px;
  color: ${colors.notice_error};
  line-height: 1.5em;
`;

export const FooterLink = styled.a`
  font-size: 14px;
  line-height: 155%;
  :active,
  :visited,
  :hover {
    color: ${colors.primaryBlue_500};
  }
`;

interface SearchPageImgs {
  bookImg: string;
  qrBookImg: string;
}

interface Iprops {
  title: string;
  children: React.ReactNode;
  annotation: JSX.Element;
  bgImg: string;
  image: string;
  bgColor: string;
  searchPageImgs: SearchPageImgs;
}

/**
 * 搜尋頁面
 */
const SearchPage: React.FC<Iprops> = ({
  title,
  children,
  annotation,
  bgImg,
  image,
  bgColor,
  searchPageImgs,
}) => {
  const returnPageName = '首頁';

  return (
    <>
      <ImgDiv>
        <PlaceImg
          image={searchPageImgs.bookImg}
          placeProps={{ height: '375px', top: '50%', left: '-5%' }}
        />
        <PlaceImg
          image={searchPageImgs.qrBookImg}
          placeProps={{ height: '313px', top: '10%', right: '0%' }}
        />
      </ImgDiv>
      <Wrapper>
        <Banner title={title} returnPageName={returnPageName} bgImg={bgImg} image={image} />
        <InnerWrapper>
          <Form bgColor={bgColor}>{children}</Form>
          <AnnotationDiv>{annotation}</AnnotationDiv>
        </InnerWrapper>
      </Wrapper>
    </>
  );
};

export default SearchPage;
